import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie, X } from "lucide-react";

const STORAGE_KEY = "fpc-cookie-notice-dismissed";

export const CookieNotice = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (window.localStorage.getItem(STORAGE_KEY)) return;
    const timer = setTimeout(() => setVisible(true), 900);
    return () => clearTimeout(timer);
  }, []);

  const dismiss = () => {
    window.localStorage.setItem(STORAGE_KEY, new Date().toISOString());
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <aside
      role="status"
      aria-live="polite"
      data-testid="cookie-notice"
      className="notice-enter fixed bottom-4 left-4 right-4 sm:left-6 sm:right-auto sm:max-w-md z-[60]"
    >
          <div className="relative flex items-center sm:items-start gap-3 sm:gap-3.5 bg-blush border border-emerald-200 rounded-2xl shadow-xl shadow-emerald-950/15 p-3 pl-4 sm:p-5 sm:pr-12">
            <span className="absolute inset-x-5 top-0 h-px bg-rosegold-metallic opacity-80" aria-hidden="true" />
            <span className="hidden sm:flex w-9 h-9 rounded-full bg-emerald-50 items-center justify-center shrink-0">
              <Cookie className="w-[18px] h-[18px] text-emerald-700" />
            </span>
            <div className="flex-1 min-w-0 text-xs sm:text-sm text-slate-600 leading-relaxed">
              <p className="hidden sm:block font-heading font-semibold text-slate-900">Essential cookies only</p>
              <p className="sm:mt-1">
                <span className="font-heading font-semibold text-slate-900 sm:hidden">Essential cookies only. </span>
                <span className="hidden sm:inline">This site uses only the essential cookies it needs to work. </span>
                No advertising or tracking cookies — ever. Read more in our{" "}
                <Link
                  to="/terms#privacy"
                  data-testid="cookie-notice-privacy-link"
                  onClick={dismiss}
                  className="font-semibold text-emerald-700 hover:text-rosegold-deep transition-colors"
                >
                  Privacy Policy
                </Link>
                .
              </p>
              <button
                type="button"
                onClick={dismiss}
                data-testid="cookie-notice-accept-btn"
                className="btn btn-secondary btn-sm mt-3 hidden sm:inline-flex"
              >
                Got it
              </button>
            </div>
            <button
              type="button"
              onClick={dismiss}
              data-testid="cookie-notice-accept-btn-mobile"
              className="btn btn-secondary btn-sm shrink-0 sm:hidden"
            >
              Got it
            </button>
            <button
              type="button"
              onClick={dismiss}
              aria-label="Dismiss cookie notice"
              data-testid="cookie-notice-close-btn"
              className="hidden sm:inline-flex absolute top-3 right-3 w-8 h-8 rounded-full items-center justify-center text-slate-400 hover:text-slate-700 hover:bg-slate-50 transition-colors"
            >
              <X className="w-4 h-4" />
            </button>
          </div>
    </aside>
  );
};
